"use client"

import { Link } from "react-router-dom";
import { Button } from "./button";
import { Badge } from "./badge";
import { cn } from "../../lib/utils";

interface CTAProps {
  badge?: {
    text: string
  }
  title: string
  description?: string
  action: {
    text: string
    href: string
    variant?: "default" | "secondary" | "destructive" | "outline" | "ghost" | "link"
  }
  withGlow?: boolean
  className?: string
}

export function CTASection({
  badge,
  title,
  description,
  action,
  withGlow = true,
  className,
}: CTAProps) {
  return (
    <section className={cn("overflow-hidden pt-0 md:pt-0", className)}>
      <div className="relative mx-auto flex max-w-container flex-col items-center gap-6 px-8 py-12 text-center sm:gap-8 md:py-24">
        {/* Badge */}
        {badge && (
          <Badge
            variant="outline"
          >
            <span className="text-muted-foreground">{badge.text}</span>
          </Badge>
        )}

        {/* Title */}
        <h2 className="text-3xl font-semibold sm:text-5xl">
          {title}
        </h2>

        {/* Description */}
        {description && (
          <p className="text-muted-foreground">
            {description}
          </p>
        )}

        {/* Action Button */}
        <Button
          variant={action.variant || "default"}
          size="lg"
          asChild
        >
          <Link to={action.href}>{action.text}</Link>
        </Button>

        {/* Glow Effect */}
        {withGlow && (
          <div className="pointer-events-none absolute inset-0 rounded-2xl shadow-[0_-16px_128px_0_hsla(var(--primary)/0.5)_inset,_0_-16px_32px_0_hsla(var(--primary)/0.5)_inset]" />
        )}
      </div>
    </section>
  )
}